/*
 * One-tap add on collection cards (Oct 16 2026).
 *
 * Tap a size chip -> POST /cart/add.js (with ?skip-cart-open=true so the
 * Shopflo app embed does not open its own cart or redirect) -> the card's
 * patch image flies in an arc into the header cart icon -> the icon bumps,
 * the cart count and the (closed) cart drawer are re-rendered from the
 * same response -> a toast confirms. The drawer is never opened here; the
 * toast's "View cart" opens it on demand.
 *
 * Publishes PUB_SUB_EVENTS.cartUpdate like product-form.js, so the free
 * gift sync, min-order lock and rewards bar keep reacting as before.
 */
(function () {
  if (window.__stpTapAdd) return;
  window.__stpTapAdd = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var toastEl = null;
  var toastTimer = null;

  function cartIconTarget() {
    var icon = document.getElementById('cart-icon-bubble');
    if (icon) {
      var r = icon.getBoundingClientRect();
      var visible = r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
      if (visible) return { x: r.left + r.width / 2, y: r.top + r.height / 2, icon: icon };
    }
    // header scrolled away: aim for the top-right corner where it lives
    return { x: window.innerWidth - 36, y: 28, icon: icon };
  }

  // The patch pops out of the tapped button (not the card photo, which can
  // be scrolled off screen) and flies into the cart icon.
  function flyToCart(img, fromEl) {
    return new Promise(function (resolve) {
      var target = cartIconTarget();
      if (!img || !fromEl || reduceMotion) return resolve(target);
      var r = fromEl.getBoundingClientRect();
      if (!r.width) return resolve(target);

      var size = 72;
      var startX = r.left + r.width / 2;
      var startY = r.top + r.height / 2;
      var clone = document.createElement('img');
      clone.className = 'stp-fly';
      clone.src = img.currentSrc || img.src;
      clone.alt = '';
      clone.style.width = size + 'px';
      clone.style.height = size + 'px';
      clone.style.left = startX - size / 2 + 'px';
      clone.style.top = startY - size / 2 + 'px';
      document.body.appendChild(clone);

      var dx = target.x - startX;
      var dy = target.y - startY;
      // arc: rise a little first, then swoop into the icon
      var lift = Math.min(120, Math.abs(dy) * 0.35 + 40);
      var endScale = 28 / size;

      if (!clone.animate) {
        clone.remove();
        return resolve(target);
      }
      var anim = clone.animate(
        [
          { transform: 'translate(0, 0) scale(0.3) rotate(0deg)', opacity: 0, offset: 0 },
          { transform: 'translate(0, -24px) scale(1.15) rotate(-6deg)', opacity: 1, offset: 0.18 },
          { transform: 'translate(' + dx * 0.3 + 'px, ' + (dy * 0.3 - lift) + 'px) scale(0.85) rotate(-10deg)', opacity: 1, offset: 0.5 },
          { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + endScale + ') rotate(12deg)', opacity: 0.6, offset: 1 },
        ],
        { duration: 950, easing: 'cubic-bezier(0.45, 0, 0.25, 1)', fill: 'forwards' }
      );
      anim.onfinish = function () {
        clone.remove();
        resolve(target);
      };
    });
  }

  function bumpCart(icon) {
    if (!icon) return;
    icon.classList.remove('stp-cart-bump');
    void icon.offsetWidth;
    icon.classList.add('stp-cart-bump');
    setTimeout(function () {
      icon.classList.remove('stp-cart-bump');
    }, 700);
  }

  function renderSections(sections) {
    if (!sections) return;
    var parse = function (html, selector) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector(selector);
      return el ? el.innerHTML : null;
    };
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var html = parse(sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && html !== null) bubble.innerHTML = html;
    }
    if (sections['cart-drawer']) {
      var drawer = document.getElementById('CartDrawer');
      var dhtml = parse(sections['cart-drawer'], '#CartDrawer');
      if (drawer && dhtml !== null) {
        drawer.innerHTML = dhtml;
        var cd = document.querySelector('cart-drawer');
        if (cd) {
          cd.classList.remove('is-empty');
          var overlay = cd.querySelector('#CartDrawer-Overlay');
          if (overlay && cd.close) overlay.addEventListener('click', cd.close.bind(cd));
        }
      }
    }
  }

  function openCart() {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.open === 'function') {
      cd.open();
    } else {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
  }

  function hideToast() {
    if (toastEl) toastEl.classList.remove('is-visible');
  }

  function showToast(opts) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'stp-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('stp-toast--error', !!opts.error);
    toastEl.innerHTML =
      '<span class="stp-toast__tick">' + (opts.error ? '!' : '✓') + '</span>' +
      '<div class="stp-toast__body"><p class="stp-toast__title"></p>' +
      (opts.item ? '<p class="stp-toast__item"></p>' : '') +
      (opts.hint ? '<p class="stp-toast__hint"></p>' : '') +
      '</div>' +
      (opts.error ? '' : '<button type="button" class="stp-toast__view">View cart</button>');
    toastEl.querySelector('.stp-toast__title').textContent = opts.title;
    if (opts.item) toastEl.querySelector('.stp-toast__item').textContent = opts.item;
    if (opts.hint) {
      var hint = toastEl.querySelector('.stp-toast__hint');
      hint.appendChild(document.createTextNode('Need another size? '));
      var a = document.createElement('a');
      a.href = opts.hintUrl;
      a.textContent = 'Open the design';
      hint.appendChild(a);
    }
    var view = toastEl.querySelector('.stp-toast__view');
    if (view) {
      view.addEventListener('click', function () {
        hideToast();
        openCart();
      });
    }
    clearTimeout(toastTimer);
    requestAnimationFrame(function () {
      toastEl.classList.add('is-visible');
    });
    toastTimer = setTimeout(hideToast, opts.error ? 4000 : 4500);
  }

  function addToCart(variantId) {
    var body = {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname,
    };
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js?skip-cart-open=true';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (json) {
        if (json.status) throw new Error(json.description || json.message || 'Could not add to cart.');
        return json;
      });
  }

  // Ink switch on 2-size x 2-ink cards (Oct 28): point each size bar at the chosen ink's variant
  document.addEventListener('click', function (e) {
    var ink = e.target.closest && e.target.closest('[data-stp-tap-add] .stp-tap-add__ink');
    if (!ink) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = ink.closest('[data-stp-tap-add]');
    var n = ink.getAttribute('data-ink');
    wrap.querySelectorAll('.stp-tap-add__ink').forEach(function (b) {
      var on = b === ink;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    wrap.querySelectorAll('[data-ink-0]').forEach(function (bar) {
      bar.setAttribute('data-variant-id', bar.getAttribute('data-ink-' + n));
      bar.setAttribute('data-size-label', bar.getAttribute('data-label-' + n));
      bar.disabled = bar.getAttribute('data-ok-' + n) !== 'true';
    });
  });

  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-stp-tap-add] .stp-tap-add__chip');
    if (!chip || chip.disabled || chip.classList.contains('is-loading')) return;
    e.preventDefault();
    e.stopPropagation();

    var wrap = chip.closest('[data-stp-tap-add]');
    var card = chip.closest('.card-wrapper') || chip.closest('.card') || wrap.parentElement;
    var img = card && card.querySelector('.card__media img');
    var title = wrap.getAttribute('data-product-title') || 'Patch';
    var sizeLabel = chip.getAttribute('data-size-label') || '';
    var isIronOn = wrap.hasAttribute('data-iron-on');

    chip.classList.add('is-loading');

    // start the flight straight away; the request runs in parallel
    var flight = flyToCart(img, chip);
    var request = addToCart(chip.getAttribute('data-variant-id'));

    Promise.all([flight, request])
      .then(function (out) {
        var target = out[0];
        var response = out[1];
        renderSections(response.sections);
        bumpCart(target.icon || document.getElementById('cart-icon-bubble'));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'stp-tap-add', productVariantId: response.items && response.items[0] && response.items[0].variant_id, cartData: response });
        }
        chip.classList.remove('is-loading');
        chip.classList.add('is-added');
        setTimeout(function () {
          chip.classList.remove('is-added');
        }, 1200);
        showToast({
          title: 'Added to cart',
          item: sizeLabel + ' · ' + title,
          hint: !isIronOn,
          hintUrl: wrap.getAttribute('data-product-url'),
        });
      })
      .catch(function (err) {
        chip.classList.remove('is-loading');
        showToast({ title: (err && err.message) || 'Could not add to cart. Please try again.', error: true });
      });
  });
})();
